module.exports = __webpack_public_path__ + "img/escudo.5351bb57.png";